import { combineReducers } from 'redux'

import campaignProposals from './campaignProposals'

export default combineReducers({
  campaignProposals,
})
